import React from 'react'
import { connect } from 'react-redux'
import { RootState } from '../../../../store/rootState'
import { IProject } from '../../types/project'
import { match } from 'react-router'
import { History } from 'history'
import { ContentHeader } from '../../../../components/Header/ContentHeader'

interface OwnProps {
  history: History
  match: match
  open: boolean
}

interface StateProps {
  project: IProject
}

type Props = StateProps & OwnProps

const ProjectDashboardHeader = (props: Props) => {

  return (
    <ContentHeader
      id='projectDashboardHeader'
      title={props.project.name}
      color='#08D6A1'
      subtitle={props.project.customer?.name ?? props.project.category}
      backLocation='/projects'
      backTitle='Dashboard'
    />
  )
}

const mapStateToProps = (state: RootState): StateProps => {
  return {
    project: state.projectsState.project
  }
}

export default connect(mapStateToProps, {})(ProjectDashboardHeader)
